import { navbarSections, NAVBAR_PATHS } from '../components/common/layouts/navbar.constants';

// The /account fallback is named like its sidebar entry ("Settings"), so the
// 403 button and the sidebar never disagree.
const ACCOUNT_SECTION = navbarSections.find((section) => section.path === NAVBAR_PATHS.account);

/**
 * The first page the given scopes actually grant access to, checked in
 * `navbarSections` order (Dashboard first, matching the sidebar's own
 * priority) — the same source of truth the sidebar itself filters against,
 * so this never drifts from what's actually visible in the nav. Falls back
 * to /account, which every authenticated FI member can reach regardless of
 * scopes (see account.js, which has no `scope` prop on its <Page>).
 *
 * Used for every "where do I land" decision that used to hardcode
 * /dashboard: post-login, "/" redirect when already authenticated, and the
 * "Go to Dashboard" fallback shown on a 403.
 *
 * @param {string[] | null | undefined} scopes
 * @returns {string}
 */
export function resolveAccessiblePath(scopes) {
    const held = scopes || [];
    const accessible = navbarSections.find((section) => held.includes(section.requiredScope));
    return accessible ? accessible.path : NAVBAR_PATHS.account;
}

/**
 * Same resolution as `resolveAccessiblePath`, but also returns the matched
 * section's label so callers can show "Go to {label}" instead of a
 * hardcoded "Go to Dashboard" that may not match the actual destination.
 * @param {string[] | null | undefined} scopes
 * @returns {{ path: string, label: string }}
 */
export function resolveAccessibleDestination(scopes) {
    const held = scopes || [];
    const accessible = navbarSections.find((section) => held.includes(section.requiredScope));
    return accessible
        ? { path: accessible.path, label: accessible.label }
        : { path: NAVBAR_PATHS.account, label: ACCOUNT_SECTION.label };
}
